import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage  } from 'react-localize-redux';
import SearchContent from 'material-ui/svg-icons/action/search';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import * as cookieServices from 'services/cookies/cookieServices';
import SearchForm from 'components/search/SearchForm';

import styles from './styles/SearchButtonStyles';

class SearchButton  extends Component {

    constructor(props) {
        super(props);

        this.getInitiaSearchDataValues = this.getInitiaSearchDataValues.bind(this);

        /*
            metodi di support per il search form per salvare la selezione
        */
        this.handleChange = this.handleChange.bind(this);
        this.handleListChange = this.handleListChange.bind(this);
        this.handleMultipleSelectionChange = this.handleMultipleSelectionChange.bind(this);
        this.handleChangeDateFrom = this.handleChangeDateFrom.bind(this);
        this.handleChangeDateTo = this.handleChangeDateTo.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleSelectedAccount = this.handleSelectedAccount.bind(this);

        /*
            per la gestione del modal popup
        */
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);

        /*
            per la gestione della ricerca
        */
        this.handleClear = this.handleClear.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleCancelSearch = this.handleCancelSearch.bind(this);

        this.state = {
            searchData: this.getInitiaSearchDataValues(props),
            modalOpen: false
        };
    }

    componentDidMount(){
        /*
            chiamo funzione di searchCallBack definita nel componente padre
            per far scattare subito la ricerca
            if(this.props.searchCallBack)
       {
           this.props.searchCallBack(this.state.searchData);
       }
        */


    }

    /**
     * modal popup - search form
     */
    handleRowClicked = (event) => {
        this.props.SaveRowIndex(event.rowIndex);
    };

    /**
     * modal popup - search form
     */
    handleOpen = () => {
        this.setState({modalOpen: true});
    };

    /**
     * modal popup - search form
     */
    handleClose = () => {
        this.setState({modalOpen: false});
    };

    /**
     * valori di default per searchData
     * @param {props dove sono state salvate le liste di severityCodeList e eventClassificationList dalla mappatura state-component} props
     */
    getInitiaSearchDataValues(props, isClear){
        var dateFrom = new Date();
        dateFrom = new Date(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate(), 0, 0, 0)
        dateFrom.setMonth(dateFrom.getMonth() - 6);
        var savedFilters = cookieServices.getSeachFilters();
        var dateTo = new Date();
        dateTo = new Date(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate(), 23, 59, 59)

        if(!isClear && savedFilters)
        {
            return {
                icnId: savedFilters.icnId,
                vin: savedFilters.vin,
                deviceFilterValue: savedFilters.deviceFilterValue,
                dateFrom: new Date(savedFilters.dateFrom),
                dateTo: new Date(savedFilters.dateTo),
                severityCodeList: props.severityCodeList,
                selectedSeverityValues: savedFilters.selectedSeverityValues,
                eventClassificationList: props.eventClassificationList,
                selectedClassificationValue: savedFilters.selectedClassificationValue,
                selectedDeviceIdType: savedFilters.selectedDeviceIdType,
                includeSubAccount: savedFilters.includeSubAccount,
                selectedAccount: savedFilters.selectedAccount
            }
        }
        return {
            icnId: '',
            vin: '',
            deviceFilterValue: '',
            dateFrom: dateFrom,
            dateTo: dateTo,
            severityCodeList: props.severityCodeList,
            selectedSeverityValues: ['AllCrashesButNonNonCrash'],
            eventClassificationList: props.eventClassificationList,
            selectedClassificationValue: null,
            selectedDeviceIdType: "ESN",
            includeSubAccount: true,
            selectedAccount: null
        }
    }


    /**
     * per gestire i valori degli input testuali del searchform
     * @param {evento input testuale} event
     */
    handleChange(event) {

        var { searchData } = this.state;
        searchData[event.target.name] = event.target.value;
        this.setState({ searchData });
    }

    /**
     * per gestire il cambio di data del searchform
     * @param {*} event
     * @param {*} date
     * @param {*} name
     */
    handleChangeDateFrom (event, date, name) {
        var { searchData } = this.state;
        if(date)
        {
            date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
        }

        searchData[name] = new Date(date);
        this.setState({ searchData });
    };

    /**
     * per gestire il cambio di data del searchform
     * @param {*} event
     * @param {*} date
     * @param {*} name
     */
    handleChangeDateTo (event, date, name) {
        var { searchData } = this.state;
        if(date)
        {
            date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
        }
        searchData[name] = date;
        this.setState({ searchData });
    };

    /**
     * gestione true - false del component Toggle del searchform
     * @param {nome del component toggle} name
     */
    handleToggle(name){
        var { searchData } = this.state;
        searchData[name] = !searchData[name];
        this.setState({ searchData });
    }

    /**
     * per gestire il selectedValue del SelectItem del searchform
     * @param {} event
     * @param {*} index
     * @param {*} response
     */
    handleListChange(name, value) {
        var { searchData } = this.state;

        searchData[name] = value;

        this.setState({ searchData });
    }

    /**
     * per gestire il selectedValue del SelectItem del searchform
     * @param {} event
     * @param {*} index
     * @param {*} response
    */
    handleMultipleSelectionChange(event, index, values, name) {
        var { searchData } = this.state;
        searchData[name] = values;
        this.setState({ searchData });
    }

    /**
     * evento di account selezionato del searchform
     * @param {selected account} item
     */
    handleSelectedAccount(item){
        var { searchData } = this.state;
        searchData.selectedAccount = item;
        this.setState({ searchData });
    }

    /**
     * ripulisce i filtri di ricerca
     */
    handleClear(){
        var { searchData } = this.state;
        searchData = this.getInitiaSearchDataValues(this.props, true);
        this.setState({ searchData });
        cookieServices.deleteSeachFilters();

        this.props.searchClearCallBack();
    }

    handleSearch(){
        /*
            il form di ricerca è dentro un modal popup
        */
        this.handleClose();

        cookieServices.saveSeachFilters(this.state.searchData);

        /*
            chiamo funzione di searchCallBack definita nel componente padre
        */
       if(this.props.searchCallBack)
       {
            this.props.searchCallBack(this.state.searchData);
       }
    }

    /**
     * annulla la ricerca in corso
     */
    handleCancelSearch(){
        /*
            chiamo funzione di searchCallBack definita nel componente padre
        */
        if(this.props.cancelSearchCallBack)
        {
                this.props.cancelSearchCallBack();
        }
    }

    render() {
        const { translate, currentLanguage, fullWidth, isSearching } = this.props;
        const { searchData } = this.state;

        var searchButton = <RaisedButton label={translate('GLOBAL.search')}
                                style={styles.searchButton}
                                onClick={this.handleSearch}
                                primary={true}>
                        </RaisedButton>;

        if(isSearching)
        {
            searchButton = <RaisedButton label={ translate('GLOBAL.searching')  }
                                style={styles.searchButton}
                                onClick={this.handleCancelSearch}
                                icon={<CircularProgress size={25} />}
                                primary={true}>
                        </RaisedButton>;
        }

        const actions = [
            <RaisedButton label={translate('GLOBAL.clear')}
                    disabled={isSearching}
                    onClick={this.handleClear}
                    secondary={true} />,
            searchButton
        ];

        var style = null;
        if(!fullWidth){
            style = {display: 'inline-block'} ;
        }

        return (
            <div style={style} >

                <RaisedButton label={translate('SearchBox.openSearchForm')}
                    labelPosition="after"
                    icon={<SearchContent />}
                    fullWidth={fullWidth}
                    onClick={this.handleOpen} />

                    <Dialog
                        title={translate('SearchBox.searchFormTitle')}
                        modal={false}
                        contentStyle={styles.searchFormModalWidth}
                        open={this.state.modalOpen}
                        autoScrollBodyContent={true}
                        actions={actions}
                        onRequestClose={this.handleClose}
                    >
                    <SearchForm
                        handleChange={this.handleChange}
                        handleListChange={this.handleListChange}
                        handleMultipleSelectionChange={this.handleMultipleSelectionChange}
                        handleSearch={this.handleSearch}
                        handleClear={this.handleClear}
                        handleChangeDateFrom={this.handleChangeDateFrom}
                        handleChangeDateTo={this.handleChangeDateTo}
                        handleToggle={this.handleToggle}
                        handleSelectedAccount={this.handleSelectedAccount}
                        searchData={searchData}
                        translate={translate}
                        currentLanguage={currentLanguage}
                        isSearching={isSearching} />
                    </Dialog>

            </div>

        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        severityCodeList: state.appData.severityCodeListForDropDown,
        eventClassificationList: state.appData.eventClassificationListForDropDown,
        //isSearching: state.icnSearch.isSearching,
        searchResults: state.icnSearch.list,
        totalCount: state.icnSearch.totalCount,
        rowIndex: state.grid.rowIndex
    };
}

SearchButton.propTypes = {
    searchCallBack: PropTypes.func.isRequired,
    searchClearCallBack: PropTypes.func.isRequired
}

export default connect(mapStateToProps)(SearchButton);


// WEBPACK FOOTER //
// ./src/containers/search/SearchButton.js